define("calendar/controllers/application", ["exports", "@ember/controller", "@ember/object", "@ember/object/computed", "@ember/runloop", "@ember/service", "@ember/utils", "tracked-built-ins"], function (_exports, _controller, _object, _computed, _runloop, _service, _utils, _trackedBuiltIns) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24;
  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/object",0,"@ember/object/computed",0,"@ember/runloop",0,"@ember/service",0,"@ember/utils",0,"tracked-built-ins"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let CalendarController = _exports.default = (_dec = (0, _computed.readOnly)('auth.currentAccount'), _dec2 = (0, _computed.readOnly)('onboarding.hasNotCompletedOnboarding'), _dec3 = (0, _computed.readOnly)('schedule.isDragging'), _dec4 = (0, _computed.readOnly)('selectedSocialProfiles.hasMultipleSelected'), _dec5 = (0, _computed.readOnly)('onboarding.onFirstOnboardingStep'), _dec6 = (0, _computed.readOnly)('mediaLibrary.selectedMedia'), _dec7 = (0, _computed.readOnly)('selectedSocialProfiles.profileIds'), _dec8 = (0, _computed.readOnly)('selectedSocialProfiles.firstProfile'), _dec9 = (0, _object.computed)('notes.@each.{isDeleted,displayNote,noteContent,color,scheduledTime,id}'), _dec10 = (0, _object.computed)('posts.@each.{smallThumbnailUrl,calendarOrProcessingUrl,isDeleted,isInstagramStory,isNew,active,startTime,id}', 'isViewingMultiple', 'singleSocialProfile', 'selectedProfileIds'), _dec11 = (0, _object.computed)('currentAccount.stopTheWorld', 'onFirstOnboardingStep', 'hasNotCompletedOnboarding'), _dec12 = (0, _object.computed)('posts.@each.startTime', 'isViewingMultiple'), (_class = class CalendarController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "mediaLibrary", _descriptor4, this);
      _initializerDefineProperty(this, "onboarding", _descriptor5, this);
      _initializerDefineProperty(this, "progressBar", _descriptor6, this);
      _initializerDefineProperty(this, "router", _descriptor7, this);
      _initializerDefineProperty(this, "schedule", _descriptor8, this);
      _initializerDefineProperty(this, "segment", _descriptor9, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor10, this);
      _initializerDefineProperty(this, "store", _descriptor11, this);
      _initializerDefineProperty(this, "userRole", _descriptor12, this);
      _initializerDefineProperty(this, "canDropOnCalendar", _descriptor13, this);
      _initializerDefineProperty(this, "showCalendarSettings", _descriptor14, this);
      _initializerDefineProperty(this, "showPinterestBusiness", _descriptor15, this);
      _initializerDefineProperty(this, "showReleaseText", _descriptor16, this);
      _defineProperty(this, "queryParams", ['calendarView']);
      _initializerDefineProperty(this, "currentAccount", _descriptor17, this);
      _initializerDefineProperty(this, "hasNotCompletedOnboarding", _descriptor18, this);
      _initializerDefineProperty(this, "isDragging", _descriptor19, this);
      _initializerDefineProperty(this, "isViewingMultiple", _descriptor20, this);
      _initializerDefineProperty(this, "onFirstOnboardingStep", _descriptor21, this);
      _initializerDefineProperty(this, "selectedMedia", _descriptor22, this);
      _initializerDefineProperty(this, "selectedProfileIds", _descriptor23, this);
      _initializerDefineProperty(this, "singleSocialProfile", _descriptor24, this);
    }
    get calendarNotes() {
      return this.notes;
    }
    get calendarPosts() {
      return this.posts;
    }
    get canCreateTimeSlots() {
      return !this.singleSocialProfile?.isPinterest && !this.singleSocialProfile?.isYoutube && this.currentAccount.canAutoSchedule && !this.isViewingMultiple;
    }
    get dropZoneText() {
      if (this.schedule.sideLibraryBehavior === 'calendar') {
        return this.intl.t('calendar.auto_schedule_drop');
      } else if (this.schedule.sideLibraryBehavior === 'preview') {
        return this.intl.t('preview_grid.add_to_preview_drop');
      }
      return '';
    }
    get enableAutoSchedule() {
      if (this.isViewingMultiple) {
        return false;
      } else if ((0, _utils.isNone)(this.schedule.sideLibraryBehavior)) {
        return false;
      }
      return this.singleSocialProfile?.hasUserTimeSlots && this.singleSocialProfile?.hasPublishingMethod;
    }
    get hasSocialProfile() {
      return (0, _utils.isPresent)(this.auth.currentGroup.socialProfiles);
    }
    get isInstagramLogin() {
      return this.selectedSocialProfiles.profiles.some(profile => profile.isInstagramLogin);
    }
    get shouldShowOnboarding() {
      return this.hasSocialProfile && this.hasNotCompletedOnboarding;
    }
    get showAutoScheduleDropZone() {
      return this.isDragging && !this.schedule.isDraggingEmptyPost && this.enableAutoSchedule && !(0, _utils.isBlank)(this.dropZoneText) && !this.isReelsPreviewGrid && !this.userRole.currentUser.needsApproval;
    }
    get socialProfilesSelectedForScheduling() {
      return this.selectedSocialProfiles.profiles.map(profile => profile.accountType);
    }
    get disableDrop() {
      return this.get('currentAccount.stopTheWorld') || this.onFirstOnboardingStep && this.hasNotCompletedOnboarding;
    }
    get targetDate() {
      return this.router.currentRoute.queryParams.targetDate;
    }
    get timelineStories() {
      let stories = this.posts.filterBy('startTime');
      const {
        isViewingMultiple,
        selectedProfileIds
      } = this;
      if (isViewingMultiple) {
        stories = stories.filter(story => selectedProfileIds.includes(story.belongsTo('socialProfile').id()) && story.get('isInstagramStory'));
      } else {
        const socialProfile = this.singleSocialProfile;
        stories = stories.filter(story => !(0, _utils.isNone)(socialProfile) && story.belongsTo('socialProfile').id() === socialProfile.get('id') && story.get('isInstagramStory'));
      }
      return stories;
    }

    // Note: This function was duplicated from the 'cluster' controller for the purposes of decoupling. It is currently used by both the side-library and calendar.
    // side-library and calendar. In a future PR, this functionality (along with other drag and drop functionality being used in both places) should be consolidated
    // into a shared service or utility.
    async autoScheduleMediaItems(mediaItems, socialProfile) {
      if (mediaItems.isAny('isGif', true) && socialProfile.isInstagram) {
        return this.alerts.warning(this.intl.t('alerts.calendar.cant_autoschedule_gif.message', {
          platform: socialProfile.accountType
        }), {
          title: this.intl.t('alerts.calendar.cant_autoschedule_gif.title')
        });
      }
      const canSchedule = await this.schedule.canSchedule(socialProfile, {
        numPosts: mediaItems.length,
        location: 'auto schedule out of posts'
      });
      if (!canSchedule) {
        return;
      }
      this.progressBar.start('.fc-view-harness');
      const mediaItemIds = mediaItems.mapBy('id');
      try {
        const response = await socialProfile.autoSchedule({
          media_item_ids: mediaItemIds,
          time_zone: this.timeZoneName
        });
        if (response.errors.length) {
          throw response.errors;
        } else {
          this.store.pushPayload(response);
          this.schedule.updatePostLimit.perform();
          this.segment.track('started-scheduling-post', {
            area: 'dragged_from_side_library_to_quick_schedule_calendar',
            type: mediaItems.firstObject.mediaType,
            is_multi_profile: this.socialProfilesSelectedForScheduling.length > 1,
            multi_profile_types: this.socialProfilesSelectedForScheduling,
            number_of_images: mediaItems.filter(mediaItem => mediaItem.mediaType === 'image').length,
            number_of_videos: mediaItems.filter(mediaItem => mediaItem.mediaType === 'video').length
          });
        }
      } catch (error) {
        const title = this.intl.t('alerts.calendar.cant_quick_schedule_a_post');
        this.errors.log(title, error);
        if (Array.isArray(error)) {
          error.forEach(_ref => {
            let {
              errors,
              media_item_id
            } = _ref;
            const mediaItem = this.store.peekRecord('media-item', media_item_id);
            const filename = mediaItem.originalFilename;
            this.alerts.warning(`${filename ? this.intl.t('alerts.calendar.skipped_quick_schedule', {
              filename
            }) : this.intl.t('alerts.calendar.skipped_quick_schedule_a_post')}<br>${errors.join()}`, {
              title: filename ? this.intl.t('alerts.calendar.cant_quick_schedule', {
                filename
              }) : title
            });
          });
        }
      } finally {
        this.progressBar.done('.fc-view-harness');
      }
    }
    deselectAll() {
      this.selectedMedia.clear();
    }
    droppedMediaItems(droppedData) {
      const self = this;
      const ids = droppedData?.split(',').filter(id => id);
      if (ids?.length) {
        const mediaItems = new _trackedBuiltIns.TrackedArray([]);
        ids.forEach(id => {
          const mediaItem = self.store.peekRecord('media-item', id);
          mediaItems.push(mediaItem);
        });
        this.send('autoScheduleMediaItems', mediaItems, this.singleSocialProfile);
      }
      this.send('deselectAll');
    }
    async editPost(gram_id) {
      try {
        await this.store.findRecord('gram', gram_id);
        this.router.transitionTo('cluster.schedule.calendar.post.edit', gram_id);
      } catch (error) {
        this.errors.log(error);
      }
    }
    onDragEnter() {
      this.send('setShowReleaseText', true);
      this.send('setCanDropOnCalendar', false);
    }
    onDragLeave() {
      this.send('setShowReleaseText', false);
      this.send('setCanDropOnCalendar', true);
    }
    onDrop(dragEvent) {
      const draggedElement = dragEvent.target;
      const dropData = dragEvent.dataTransfer.getData('text');
      this.send('setCanDropOnCalendar', false);
      if (!dropData) {
        this.send('droppedMediaItems', draggedElement);
      } else {
        this.send('droppedMediaItems', dropData);
      }
      this.send('setCanDropOnCalendar', true, 300);
    }
    showQuickScheduleWizard() {
      this.schedule.isQuickScheduleWizardVisible = true;
    }
    setCanDropOnCalendar() {
      let bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      let timeout = arguments.length > 1 ? arguments[1] : undefined;
      if (timeout) {
        (0, _runloop.later)(() => this.canDropOnCalendar = bool, timeout);
      } else {
        this.canDropOnCalendar = bool;
      }
    }
    setShowReleaseText(bool) {
      this.set('showReleaseText', bool);
    }
    trackOnboardingStep(eventName) {
      this.onboarding.trackOnboardingStep(eventName);
    }
    updateTargetDate(dateInCurrentRange) {
      this.router.replaceWith(this.router.currentRouteName, {
        queryParams: {
          ...this.router.currentRoute.queryParams,
          targetDate: dateInCurrentRange
        }
      });
    }
    viewCalendarSettings() {
      this.segment.track('clicked-calendar-settings');
      this.showCalendarSettings = true;
    }
    closeCalendarSettings() {
      this.showCalendarSettings = false;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "mediaLibrary", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "progressBar", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "schedule", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "userRole", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "canDropOnCalendar", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "showCalendarSettings", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "showPinterestBusiness", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "showReleaseText", [_trackedBuiltIns.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "currentAccount", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "hasNotCompletedOnboarding", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "isDragging", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "isViewingMultiple", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "onFirstOnboardingStep", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "selectedMedia", [_dec6], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "selectedProfileIds", [_dec7], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "singleSocialProfile", [_dec8], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "calendarNotes", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "calendarNotes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "calendarPosts", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "calendarPosts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableDrop", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "disableDrop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timelineStories", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "timelineStories"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "autoScheduleMediaItems", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "autoScheduleMediaItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deselectAll", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "deselectAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "droppedMediaItems", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "droppedMediaItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editPost", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragEnter", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDragLeave", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onDragLeave"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDrop", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onDrop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showQuickScheduleWizard", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "showQuickScheduleWizard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCanDropOnCalendar", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setCanDropOnCalendar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowReleaseText", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowReleaseText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackOnboardingStep", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackOnboardingStep"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateTargetDate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateTargetDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "viewCalendarSettings", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "viewCalendarSettings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeCalendarSettings", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeCalendarSettings"), _class.prototype)), _class));
});